import * as sentry from '@sentry/react';
import { appEnv } from 'shiver-core/env';
import { guardState } from './browser-back-guard-state.ts';

if (appEnv !== 'local') {
  sentry.init({
    dsn: 'https://1e857c4700c51a96ba84e846959f84c2@o4509904843440128.ingest.us.sentry.io/4510475797725184',
    environment: appEnv,
    ignoreErrors: [
      // https://github.com/getsentry/sentry-javascript/issues/3440
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      // https://github.com/DataDog/browser-sdk/issues/2715
      /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
    ],
  });
}

// TODO: 本番環境で正しくSentryにキャプチャされるか確認したら消す
if (window.localStorage.getItem('ls-internal-check-sentry') === 'error') {
  throw new Error('ls-internal-check-sentry: error');
}
if (window.localStorage.getItem('ls-internal-check-sentry') === 'unhandledrejection') {
  Promise.reject(new Error('ls-internal-check-sentry: unhandledrejection'));
}

// BrowserBackUnsavedGuard 用グローバル popstate リスナー。
// このファイルはアプリ起動時に実行されるため、react-router の popstate リスナーより
// 先に登録される。stopImmediatePropagation() で react-router への伝播を遮断できる。
window.addEventListener('popstate', (event) => {
  const currentIdx = (window.history.state?.idx as number | null | undefined) ?? null;

  if (guardState.suppressNext) {
    // confirm OK/cancel 後の history.go() / dispatchEvent による popstate: react-router に委譲する
    guardState.suppressNext = false;
    return;
  }

  if (!guardState.isActive) {
    return;
  }

  // ガード発動: react-router への伝播を遮断して confirm を表示
  const prevIdx = guardState.lastIdx;
  const goingBack = prevIdx !== null && currentIdx !== null ? currentIdx < prevIdx : true;
  const delta = goingBack ? -1 : 1;
  event.stopImmediatePropagation();

  const ok = window.confirm(guardState.message);

  if (ok) {
    // 確認 OK: 現在の state で PopStateEvent を再発火して react-router に処理させる
    // history.go() を使うと履歴がさらに移動してしまうため dispatchEvent を使う
    guardState.lastIdx = currentIdx;
    guardState.suppressNext = true;
    window.dispatchEvent(
      new PopStateEvent('popstate', { state: window.history.state, bubbles: false }),
    );
  } else {
    // キャンセル: URL を元のページに復元
    guardState.suppressNext = true;
    window.history.go(-delta);
  }
});
